import { LegacyFit } from '../../brunswick/constants/LegacyFit'

/**
 * @deprecated Use ProductCatalog types rather than Zidi types.
 */
export function isColorAvailable({
  availableProducts,
  colorKey,
  selectedFitKey,
  selectedSizeShorthand,
}: {
  availableProducts: AvailableProducts
  colorKey: string
  selectedFitKey: string | undefined
  selectedSizeShorthand?: string
}): boolean {
  if (!selectedFitKey) return false
  const sizesInColorAndFit = availableProducts[colorKey]?.[selectedFitKey] ?? []
  return selectedSizeShorthand
    ? sizesInColorAndFit.includes(selectedSizeShorthand)
    : sizesInColorAndFit.length > 0
}

/**
 * @deprecated Use ProductCatalog types rather than Zidi types.
 */
export function deriveColorsWithUnavailable<Color extends { rawName: string }>({
  availableProducts,
  colors,
  selectedFitKey,
  selectedSizeShorthand,
}: {
  availableProducts: AvailableProducts
  colors: readonly Color[]
  selectedFitKey: string | undefined
  selectedSizeShorthand?: string
}): Array<Color & { unavailable: boolean }> {
  return colors.map(color => {
    return {
      ...color,
      unavailable: !isColorAvailable({
        availableProducts,
        colorKey: color.rawName,
        selectedFitKey,
        selectedSizeShorthand,
      }),
    }
  })
}

type SizeShorthand = string

/**
 * @deprecated Use ProductCatalog types rather than Zidi types.
 */
export interface AvailableProducts {
  [colorKey: string]:
    | {
        [fitKey: string]: SizeShorthand[] | undefined
      }
    | undefined
}

/**
 * @deprecated Use ProductCatalog types rather than Zidi types.
 */
export function deriveAvailableProducts<
  T extends {
    availableSizes: string[]
    colorInfo: {
      rawName: string
    } | null
    rawFit: string | null
  },
>(products: T[]): AvailableProducts {
  const availableProducts: AvailableProducts = {}

  for (const { availableSizes, colorInfo, rawFit } of products) {
    if (!colorInfo || !colorInfo.rawName) continue
    if (!rawFit) continue
    const availableFitsInColor = availableProducts[colorInfo.rawName] ?? {}
    availableFitsInColor[rawFit] = availableSizes
    availableProducts[colorInfo.rawName] = availableFitsInColor
  }

  return availableProducts
}

/**
 * @deprecated Use ProductCatalog types rather than Zidi types.
 */
export function isColorFitComboValid({
  availableProducts,
  colorKey,
  fitKey,
}: {
  availableProducts: AvailableProducts
  colorKey: string
  fitKey: string | undefined
}): boolean {
  return !!(fitKey && availableProducts[colorKey]?.[fitKey])
}

/**
 * @deprecated Use ProductCatalog types rather than Zidi types.
 */
export function getValidatedFit({
  availableProducts,
  colorKey,
  fitKey,
}: {
  availableProducts: AvailableProducts
  colorKey: string
  fitKey: string | undefined
}): string {
  if (!fitKey) return LegacyFit.Regular

  if (isColorFitComboValid({ availableProducts, colorKey, fitKey })) return fitKey

  // Fallbacks:
  if (isColorFitComboValid({ availableProducts, colorKey, fitKey: LegacyFit.Regular })) {
    return LegacyFit.Regular
  }
  if (isColorFitComboValid({ availableProducts, colorKey, fitKey: LegacyFit.Petite })) {
    return LegacyFit.Petite
  }
  if (isColorFitComboValid({ availableProducts, colorKey, fitKey: LegacyFit.Tall })) {
    return LegacyFit.Tall
  }
  return LegacyFit.Regular
}
